import { render, staticRenderFns } from "./SectionBCard.vue?vue&type=template&id=506f3952&"
import script from "./SectionBCard.vue?vue&type=script&lang=js&"
export * from "./SectionBCard.vue?vue&type=script&lang=js&"
import style0 from "./SectionBCard.vue?vue&type=style&index=0&id=506f3952&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports